import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";

const useStyles = makeStyles(({ zIndex }: Theme) => ({
    wrapper: {
        position: "absolute",
        zIndex: zIndex.drawer,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgba(255,255,255,0.8)"
    }
}));

export const _TableLoader: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.wrapper}>
            <CircularProgress size={24} />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/TableLoader.tsx